import React from "react";
import { IconType } from "react-icons";
import styles from "./StoreButton.module.scss";

interface StoreButtonProps {
  href: string;
  src?: string;
  alt?: string;
  theme?: "light" | "dark";
  icon?: IconType;
  text?: string;
}

export const StoreButton: React.FC<StoreButtonProps> = ({
  href,
  src,
  alt,
  theme = "light",
  icon: Icon,
  text,
}) => {
  const isImage = src && alt;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`${styles.storeLink} ${styles[theme]}`}
    >
      {isImage ? (
        <img src={src} alt={alt} className={styles.storeBadge} />
      ) : (
        <div className={styles.customButton}>
          {Icon && <Icon size={22} />}
          {text && <span>{text}</span>}
        </div>
      )}
    </a>
  );
};